<template>
  <div>
    <ServiceRequestCreate ref="serviceRequestCreate" :policy="policy" :serviceRequestType="serviceRequestKey" :initialID="ID" @onDataRetrived="onDataRetrived">
      <div slot="serviceRequestType" slot-scope="row">
        <div v-if="!row.status || row.status === 'PEN'">
          <FITSelect :rule="{required:true}" field="paymentMethod" :label="getLabel('paymentMethod')" v-model="form.paymentMethod" :options="paymentMethod" :width="columnWidth" :disabled="row.isLocked"></FITSelect>
          <FITTextInput :rule="{required:true, policy:true}" field="paymentReference" :label="getLabel('paymentReference')" v-model="form.paymentReference" :width="columnWidth" :disabled="row.isLocked"></FITTextInput>
          <!-- <FITSelect :label="getLabel('companyBank')" v-model="form.companyBank" :options="companyBank" :width="columnWidth" :disabled="row.isLocked"></FITSelect> -->
          <!-- <FITDatePicker :label="getLabel('paymentDate')" v-model="form.paymentDate" :width="columnWidth" :disabled="row.isLocked"></FITDatePicker> -->
        </div>
        
        <div v-else>
          <ServiceRequestDetailRow :field="getLabel('paymentMethod')" :value="form.modalPremium"></ServiceRequestDetailRow>
          <ServiceRequestDetailRow :field="getLabel('paymentReference')" :value="form.modalPremium"></ServiceRequestDetailRow>
          <!-- <ServiceRequestDetailRow :field="getLabel('paymentDate')" :value="form.modalPremium"></ServiceRequestDetailRow> -->
          <!-- <ServiceRequestDetailRow :field="getLabel('modalPremium')" :value="form.modalPremium"></ServiceRequestDetailRow> -->
        </div>
       
      </div>
    </ServiceRequestCreate>
  </div>
</template>
<script type="text/javascript">
import ServiceRequestCreate from '../ServiceRequestCreate'

import {
  FITTextInput,
  FITButton,
  FITAutoSearch,
  FITSelect,
  FITTextarea,
  FITDatePicker
} from '@/components'
import ServiceRequestDetailRow from '../ServiceRequestDetailRow'

import { mapGetters, mapState } from 'vuex'
import Vue from 'vue'
export default {
  name: 'ChangePaymentMethod',
  components: {
    ServiceRequestCreate,
    FITTextInput,
    FITButton,
    FITAutoSearch,
    FITSelect,
    FITDatePicker,
    FITTextarea,
    ServiceRequestDetailRow
  },

  methods: {
    getLabel(field) {
      return this.$t(`osm.serviceRequest.type.${this.serviceRequestKey}.${field}`);
    },
    onDataRetrived(data) {
      this.selectedType.list
        .forEach((column) => {
          Vue.set(this.form, column.fieldColumn, this.selectedType.data[column.fieldColumn])
        })
    }
  },

  data() {
    return {
      type: {},
      form: {
        paymentMethod: '',
        paymentReference: '',
        companyBank: '',
        paymentDate: ''
      },
      serviceRequestKey: 'CPM'
    }
  },

  props: {
    ID: {
      type: Number,
      default: null
    },

    policy: {
      type: Object,
      default: null
    }
  },

  computed: {
    columnWidth() {
      if (this.$refs.serviceRequestCreate) {
        return this.$refs.serviceRequestCreate.option.data.column;
      }
      return 10;
    },

    ...mapGetters('ServiceRequest', [
      'getTranslated',
      'getTranslatedArray',
      'getTranslatedString',
      'isValueModified',
      'getServiceRequestTranslated'
    ]),

    ...mapState('ServiceRequest', [
      'fields',
      'selectedType'
    ]),

    paymentMethod() {
      return this.getTranslated(this.$i18n.locale, 'paymentMethod', 'selectedType');
    },

    companyBank() {
      return this.getTranslated(this.$i18n.locale, 'companyBank', 'selectedType');
    }
  },

  created() {
    if (!this.policy) {
      console.debug(this.serviceRequestKey, 'Null policy ID when routing to service request');
      return
    }
  },

  watch: {
    form: {
      deep: true,
      handler(val) {
        this.$store.commit({
          type: 'ServiceRequest/setTypeForm',
          form: JSON.parse(JSON.stringify(val))
        })
      }
    },
    'selectedType.data': {
      deep: true,
      handler(val) {
        Vue.set(this.form, 'ID', val.ID);
      }
    }
  }

}

</script>



// WEBPACK FOOTER //
// src/Osm/ServiceRequest/components/ServiceRequestTypes/ChangePaymentMethod.vue